<div class="contact-page">
  <app-header-style-seven></app-header-style-seven>

  <section class="page-shell contact-shell">
    <div class="custom-container">
      <div class="content-shell contact-content-shell">
        <!-- HERO -->
        <header class="page-hero">
          <span class="page-kicker">Get in Touch</span>
          <h1>Contact Us</h1>
          <p>
            Reach out to the college for admissions, academic support, online exam
            enquiries, and general communication. Our team will be happy to assist you.
          </p>
        </header>

        <!-- CONTACT INFO -->
        <section
          class="info-card"
          [class.dark-contact-info-area]="themeService.isDark()"
        >
          <div class="panel-head info-head">
            <div>
              <span class="panel-tag">Contact Information</span>
              <h2>How to Reach Us</h2>
            </div>
          </div>

          <div class="contact-grid">
            <!-- EMAIL -->
            <article class="contact-card">
              <div class="contact-icon">
                <i class="bx bx-envelope"></i>
              </div>
              <h3>Email Here</h3>
              <a href="mailto:principal@fmcet.ac.in">principal&#64;fmcet.ac.in</a><br><br>
              <a href="mailto:principal@fmcet.ac.in">mr&#64;fmcet.ac.in</a>
            </article>

            <!-- LOCATION -->
            <article class="contact-card">
              <div
                class="contact-icon is-clickable"
                role="button"
                tabindex="0"
                aria-label="View campus location map"
                title="View Map"
                (click)="scrollToMap()"
                (keyup.enter)="scrollToMap()"
              >
                <i class="bx bx-map"></i>
              </div>

              <h3>Location Here</h3>
              <p>
                <a
                  href="https://goo.gl/maps/vpK16J7zFHHrzPJR8"
                  target="_blank"
                  rel="noopener"
                >
                  Madurai Sivagangai Main Road, Madurai - 625 020, Tamil Nadu, India.
                </a>
              </p>

              <button type="button" class="map-link-btn" (click)="scrollToMap()">
                View Campus Map
              </button>

              <div class="route-block">
                <h4>Bus Routes</h4>
                <p>Mattuthavani Bus Terminal to Poovanthi</p>
                <p>Periyar Bus Terminal to Poovanthi</p>
                <p>Sivagangai Bus Terminal to Poovanthi</p>
              </div>
            </article>

            <!-- PHONE -->
            <article class="contact-card">
              <div class="contact-icon">
                <i class="bx bx-phone-call"></i>
              </div>

              <h3>Admission Enquiry</h3>
              <p><a href="tel:+919942982322">+91 99429 82322</a></p>
              <p><a href="tel:+919942982311">+91 99429 82311</a></p>
              <p><a href="tel:+919942982321">+91 99429 82321</a></p>

              <div class="route-block">
                <h4>Online Exam Enquiry</h4>
                <p><a href="tel:+919786656660">+91 97866 56660</a></p>
              </div>
            </article>
          </div>
        </section>

        
    

        <!-- MAP -->
        <section class="panel-card map-panel" id="campus-map" #campusMapSection>
          <div class="panel-head">
            <div>
              <span class="panel-tag">Campus Location</span>
              <h2>Find Us on Map</h2>
            </div>

            <a
              class="pdf-link"
              href="https://goo.gl/maps/vpK16J7zFHHrzPJR8"
              target="_blank"
              rel="noopener"
            >
              Open in Google Maps
            </a>
          </div>

          <div class="map-wrap">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d15703889.85866086!2d67.755781087162!3d16.067695853589544!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3b00c2b4dd324e27%3A0x3cb4022e24382992!2sFatima%20Michael%20College%20of%20Engineering%20%26%20Technology!5e0!3m2!1sen!2sin!4v1691426272519!5m2!1sen!2sin"
              loading="lazy"
              referrerpolicy="no-referrer-when-downgrade"
              allowfullscreen
              title="Fatima Michael College of Engineering and Technology Map"
            ></iframe>
          </div>
        </section>
      </div>
    </div>
  </section>
</div>